export enum EstadosMesaType {
  DISPONIBLE = "disponible",
  RESERVADO = "reservado",
  OCUPADO = "ocupado",
  EN_PROCESO = "en_proceso"
}
